import type { OnboardingEntryDecision } from "~/pages/SupplierPortal/Onboarding/utils/onboardingEntryDecision"

export const GATE_FAILURE_SOURCE = {
  FEATURE_FLAG: "featureFlag",
  ONBOARDING_STATE: "onboardingState",
} as const

export type GateFailureSource =
  (typeof GATE_FAILURE_SOURCE)[keyof typeof GATE_FAILURE_SOURCE]

export type GateFailure = Readonly<{
  source: GateFailureSource
  error: Error
}>

export type GateState =
  | { status: "loading" }
  | { status: "authError"; error: Error }
  | {
      status: "retryable"
      source: GateFailureSource
      retry: () => void
    }
  | { status: "ready"; decision: OnboardingEntryDecision }

export type ResolveGateStateInput = Readonly<{
  decision: OnboardingEntryDecision | null
  isLoading: boolean
  isAuthError: boolean
  authError: Error | null
  gateFailure: GateFailure | null
  retry: () => void
}>

export const resolveGateState = ({
  decision,
  isLoading,
  isAuthError,
  authError,
  gateFailure,
  retry,
}: ResolveGateStateInput): GateState => {
  if (isLoading) {
    return { status: "loading" }
  }

  if (isAuthError && authError !== null) {
    return { status: "authError", error: authError }
  }

  if (gateFailure !== null) {
    return {
      status: "retryable",
      source: gateFailure.source,
      retry,
    }
  }

  if (decision === null) {
    return { status: "loading" }
  }

  return { status: "ready", decision }
}
